export const OBJECT_TYPE_LIST_ACTION = "OBJECT_TYPE_LIST_ACTION";
export const OBJECT_TYPE_LIST_SUCCESS = "OBJECT_TYPE_LIST_SUCCESS";

export const OBJECT_TYPE_ALL_ACTION = "OBJECT_TYPE_ALL_ACTION";
export const OBJECT_TYPE_ALL_SUCCESS = "OBJECT_TYPE_ALL_SUCCESS";

export const OBJECT_TYPE_LIST_FAIL = "OBJECT_TYPE_LIST_FAIL";
export const OBJECT_TYPE_DELETE_TRANSLATE_SUCCESS = "OBJECT_TYPE_DELETE_TRANSLATE_SUCCESS";

export const OBJECT_TYPE_DETAIL_ACTION = "OBJECT_TYPE_DETAIL_ACTION";
export const OBJECT_TYPE_DETAIL_DELETE_ACTION = "OBJECT_TYPE_DETAIL_DELETE_ACTION";
export const OBJECT_TYPE_DETAIL_SUCCESS = "OBJECT_TYPE_DETAIL_SUCCESS";
export const OBJECT_TYPE_DETAIL_FAIL = "OBJECT_TYPE_DETAIL_FAIL"

export const OBJECT_TYPE_DETAIL_UPDATE_ACTION = "OBJECT_TYPE_DETAIL_UPDATE_ACTION";
export const OBJECT_TYPE_DETAIL_CREATE_ACTION = "OBJECT_TYPE_DETAIL_CREATE_ACTION";

export const OBJECT_TYPE_CREATE_TRANSLATE_ACTION = "OBJECT_TYPE_CREATE_TRANSLATE_ACTION";
export const OBJECT_TYPE_UPDATE_TRANSLATE_ACTION = "OBJECT_TYPE_UPDATE_TRANSLATE_ACTION";
export const OBJECT_TYPE_DELETE_TRANSLATE_ACTION = "OBJECT_TYPE_DELETE_TRANSLATE_ACTION";

export const OBJECT_TYPE_CREATE_TRANSLATE_SUCCESS = "CATEGORY_CREATE_TRANSLATE_SUCCESS";
export const OBJECT_TYPE_UPDATE_TRANSLATE_SUCCESS = "OBJECT_TYPE_UPDATE_TRANSLATE_SUCCESS";
export const OBJECT_TYPE_FAIL = "OBJECT_TYPE_FAIL";